import React from 'react';
import Container from 'container';
import Headline from 'headline';
import ArticleCard from 'shared/article-card';
import { Link } from 'gatsby';
import categories from 'data/categories.json';
import Icon from 'icon';

import s from './article_group_5.module.scss';

const demoArticle = {
  title: 'This is the article title',
  date: '2019-05-23T18:38:10',
  image: 'placeholder',
  excerpt: `
    <p>
    Lorem ipsum, dolor sit amet consectetur adipisicing elit. Exercitationem
    ab aliquid accusantium molestiae temporibus in, inventore est nam veniam
    quia neque vel voluptates reiciendis eos alias accusamus id nemo quam
    fugiat porro consectetur nesciunt. Et fuga culpa dolore! Modi reiciendis
    aliquid nostrum illo doloribus reprehenderit eveniet laboriosam blanditiis
    in, accusamus, natus nemo maxime iure, voluptatem ipsum? Odio
  </p>`,
  categories: ['travel'],
  author: 'Joseph Casanova',
  editor: 'Elizabeth Williams',
  illustrator: 'Alexis Michaud'
};

export default function ArticleGroup5({
  articles = new Array(4).fill(demoArticle),
  title = '<h4>headline title</h4>',
  category
}) {
  const catName = categories[category]?.name;
  const catSlug = categories[category]?.slug;
  return (
    <Container className={s.root}>
      <div className={s.wrapper}>
        <Headline h2 className={s.headline} html={title} />
        <Link className={`${s.viewAll} ${s.desktop}`} to={`/${catSlug}/`}>
          <span>{`View all ${catName} posts`}</span>
          <Icon className={s.arrow} icon="arrow-circle" />
        </Link>
      </div>
      <div className={s.cards} key={`group-articles-page-${Math.random()}`}>
        {articles.map(card => (
          <div className={s.article}>
            <ArticleCard
              small
              {...card}
              key={card.title}
              slim
              className={s.card}
            />
          </div>
        ))}
      </div>
      <Link className={`${s.viewAll} ${s.mobile}`} to={`/${catSlug}/`}>
        <span>{`View all ${catName} posts`}</span>
        <Icon className={s.arrow} icon="arrow-circle" />
      </Link>
    </Container>
  );
}
